module.exports = __webpack_public_path__ + "static/Henoscene-Final-Logo-All-White-b163d23f6ca4b04e88b867ae45050a84.png";